import React from 'react'
import { Row, Column, Intro } from 'components/Layout'
import { Background, Modal } from 'components/Overlay'
import { SlideIn } from 'components/Transitions'

import { Image } from 'components/Image'

import letsExplore from '../../assets/intros/guys-compiling.png'

const Loading = () => {
	return (
		<SlideIn from="bottom">
			<Background light>
				<Modal>
					<Row center>
						<Column width={4} center>
							<Intro header={"It's compiling..."} center />
						</Column>
					</Row>
					<Row center>
						<Column width={4} center>
							<Image
								src={letsExplore}
								width={330}
								height={270}
								style={{ margin: '0 auto' }}
							/>
						</Column>
					</Row>
				</Modal>
			</Background>
		</SlideIn>
	)
}
export default Loading



// WEBPACK FOOTER //
// ./src/views/Common/Loading.js